
import { Quests } from "@/models/MapPois/Quest/Quests";
import DeleteBoxEditable from "../../../Base/DeleteBoxEditable.vue";
import { forIn } from "lodash";
import { Game } from "@/models/Game";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { DeleteBoxEditable },
})
class QuestErrors extends Vue {
  @Prop({ default: null }) readonly questData!: Quests;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  get getErrorArray(): string[] {
    const arr: string[] = [];
    forIn(this.questData.issues?.err, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }
  get getWarningArray(): string[] {
    const arr: string[] = [];
    forIn(this.questData.issues?.warn, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }
  openReinstateDeleteBox(): void {
    this.$bvModal.show("team-modal-delete-editable");
  }
  reinstateQuest(): void {
    var data = {
      parentUid: this.gameData.clone_parent,
      gameUid: this.gameData.key,
      key: this.questData.key,
      quest: this.questData,
    };
    this.$store.dispatch("mapPoiStore/reinstateQuest", data);
    this.$emit("runErrorCheck");
    this.$emit("closeDialog");
  }
}

export default QuestErrors;
